import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';

@Component({
  selector: 'app-copy-advice-progress-dialog',
  templateUrl: './copy-advice-progress-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CopyAdviceProgressDialogComponent extends AbstractDialog<never> {  readonly data = inject<AbstractDialogData>(MAT_DIALOG_DATA);
  protected readonly mdDialogRef = inject<MatDialogRef<CopyAdviceProgressDialogComponent, AbstractDialogResultData<never>>>(MatDialogRef);

}
